import { useMutation } from "@shared/lib/hooks";
import { CampaignService } from "../services/BillingBrand.service";
import { ToastService } from "@shared/lib/services";
import {
  BILLING_BRAND_LIST_QUERY_KEY,
  BILLING_BRAND_DETAILS_QUERY_KEY,
  BILLING_BRAND_FACETS_QUERY_KEY,
} from "../constants";

interface LinkBrandToBillingParams {
  billingId: string;
  brandIds: string[];
}

export function useLinkBrandToBilling() {
  const {
    mutate: link,
    isLoading: isLinking,
    isSuccess: isLinked,
    error,
  } = useMutation<LinkBrandToBillingParams>({
    mutationFn: async ({ billingId, brandIds }) => {
      try {
        return await CampaignService.linkBrandToBilling(billingId, brandIds);
      } catch (err: any) {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }
    },
    options: {
      queryKey: BILLING_BRAND_LIST_QUERY_KEY,
    },
    onSuccess: (c, data, { billingId }) => {
      c.invalidateQueries({ queryKey: BILLING_BRAND_LIST_QUERY_KEY });
      c.invalidateQueries({ queryKey: BILLING_BRAND_FACETS_QUERY_KEY });
      c.invalidateQueries({
        queryKey: BILLING_BRAND_DETAILS_QUERY_KEY(billingId),
      });
    },
  });

  return {
    link,
    isLinking,
    isLinked,
    error,
  };
}
